module.exports = __webpack_public_path__ + "media/images/logos/London-School-of-Economics-be9d950f2f191e8189ddca19d8b490d8.svg";